import { TableBody, TableCell, TableRow } from "@material-ui/core";
import React, { Fragment } from "react";
import { useSelector } from "react-redux";

import { colorType } from "../../../model/Common";
import { selector as registerStoreSelector } from "../../../store/RegisterStore";
import useStyles from "../useStyles";

/**
 * RegisterTableBodyコンポーネント.
 *
 * @return {object} コンポーネント
 */
function RegisterTableBody() {
  // スタイル
  const styles = useStyles();

  // Store情報
  const {
    // アップロード履歴
    history,
  } = useSelector(registerStoreSelector);

  const styleUploadResult = (result) => {
    let style;
    switch (result) {
      case true:
        style = { color: "limegreen", fontWeight: "bold" };
        break;
      case false:
        style = { color: "red", fontWeight: "bold" };
        break;
      default:
        style = undefined;
        break;
    }
    return style;
  };

  return (
    <TableBody className={styles.registerTableBody}>
      {!history || !history.length ? (
        <TableRow>
          <TableCell>-</TableCell>
          <TableCell>-</TableCell>
          <TableCell>-</TableCell>
        </TableRow>
      ) : (
        <>
          {history.map((item) => (
            <Fragment key={item.timestamp}>
              {item.fileName ? (
                <TableRow>
                  <TableCell>{item.timestamp}</TableCell>
                  <TableCell>{item.fileName}</TableCell>
                  <TableCell style={styleUploadResult(item.result)}>
                    {item.result ? "成功" : "失敗"}
                  </TableCell>
                </TableRow>
              ) : (
                <TableRow style={{ background: colorType.myosotis }}>
                  <TableCell
                    colSpan={3}
                    style={{ fontWeight: "bold" }}
                  >{`ファイルアップロード総数：${item.total} / DB登録成功ファイル数：${item.success}`}</TableCell>
                </TableRow>
              )}
            </Fragment>
          ))}
        </>
      )}
    </TableBody>
  );
}

export default RegisterTableBody;
